module.exports = __webpack_public_path__ + "static/media/default-avatar.996f89ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/avatar/default-avatar.svg
// module id = 788
// module chunks = 0